import { computed } from 'vue';

export default function useHeader({ store, router }) {
  const USER_CITY = computed(() => store.getters['user/city']);
  const USER_INFO = computed(() => store.getters['user/account']);
  const LOGGED_IN = computed(() => store.getters['user/loggedIn']);

  const getHeader = () => {
    const resolutionWidth = Math.floor(window.innerWidth * window.devicePixelRatio);
    const resolutionHeight = Math.floor(window.innerHeight * window.devicePixelRatio);

    return {
      timestamp: Date.now(),
      location: {
        id: USER_CITY.value.id,
        name: USER_CITY.value.name,
      },
      screen: {
        resolution: `${resolutionWidth}x${resolutionHeight}`,
        viewPortSize: `${window.visualViewport?.width}x${window.visualViewport?.height}`,
      },
      user: {
        isAuthorized: LOGGED_IN.value,
        uid: USER_INFO.value.id ?? null,
        clubproId: USER_INFO.value.id ?? null,
      },
      page: {
        pageLocation: window.location.href,
        pageTitle: document.title,
        pageReferrer: document.referrer || null,
        pageType: router.currentRoute.value.meta?.mnemonicCode ?? 'Other',
      },
    };
  };

  return {
    getHeader,
  };
}
